import { createSelector } from 'reselect';
import { homepageCarouselRatingsSelector } from 'selectors/testTarget/offers/homepageCarouselRatings/homepageCarouselRatingsSelector';

/**
 * Returns a boolean indicating whether the offer's `enabled` field is truthy.
 */
const enabledSelector = createSelector(homepageCarouselRatingsSelector, homepageCarouselRatings => !!homepageCarouselRatings.enabled);

export { enabledSelector };
